//SHOW SIZE WITH SQUARE(BOXES)
$(document).ready(function(){
  	changePreview();
  });
  
  

$("#SingleOptionSelector-0").on('change', function() {
  var valPreview=$("#valPreview").val();

  if(valPreview == 2){
    $("#SingleOptionSelector-0").val(1).change();
  }

});

 
function changePreview()
{      
  var totalPro = $("#totalPro").val();
  var valPreview = $("#valPreview").val();
  if(valPreview == 2)
  {
    /*$('#BIS_trigger').remove();
        if(totalPro > 0){

        	$('#showButton').html("<br><button href='#' style='' id='BIS_trigger' class='Button Button--primary' >EMAIL WHEN AVAILABLE</button>");
        }*/
    $("#SingleOptionSelector-0").val(1).change();

  }
}
  


function size0(nameInput, id0)
{
  var info = $("#info").val();
  var showS = $("#valSize").val();

  $("#showSize").empty();
  $("#showSize").append(showS);
  //$("#SingleOptionSelector-0").val(showS).change();

  if(nameInput != info ){
    if(id0 == 2){
      document.getElementById(nameInput).style.border = "solid #EAEBED 0px";
      document.getElementById(nameInput).style.border = "1px solid #EAEBED";
      document.getElementById(nameInput).style.background = "white";
      document.getElementById("txt-"+nameInput).style.color="#5F6163";
      document.getElementById("txt-"+nameInput).style.fontWeight= "normal";
      document.getElementById("txt-"+nameInput).style.opacity="0.3";
    }else{
      document.getElementById(nameInput).style.border = "solid #EAEBED 0px";
      document.getElementById(nameInput).style.border = "1px solid #EAEBED";
      document.getElementById(nameInput).style.background = "white";
      document.getElementById("txt-"+nameInput).style.color="#5F6163";
    }
  }
}
  

//SHOW SIZE IN LABEL
  function showSize(nameZize, id)
  {
    $("#showSize").empty();
    $("#showSize").append(nameZize);
    if(id == 2){
     	 document.getElementById(nameZize).style.background = "linear-gradient(to top right, #EAEBED 0%, #EAEBED calc(50% - 3px), rgba(255,255,255,255) 50%, #EAEBED calc(50% + 3px), #EAEBED 100%)";
         document.getElementById("txt-"+nameZize).style.color="#5F6163";
         document.getElementById("txt-"+nameZize).style.opacity="1";
         document.getElementById("txt-"+nameZize).style.fontWeight= "bold";
    }else{
         document.getElementById(nameZize).style.background = "gray";
         document.getElementById("txt-"+nameZize).style.color="white";
    }
    
  }
  
  

//WHEN USER PRESS CLICK
function fnChangeBorder(boxId, id, title)
{
  
   $("#valSize").val(boxId);
   var showEmail = $("#showEmail").val();
   var valShow = $("#valShow").val();
   var str = boxId;
   str = str.replace(/^\s*|\s*$/g,"");
   var s=$('#info').val();
   $("#id").val(str).change();
  
    if(id == 2){
         $('#BIS_trigger').remove();
      	 $('#showButton').html("<br><button href='#' style='' id='BIS_trigger' class='Button Button--primary' >EMAIL WHEN AVAILABLE</button>");
         document.getElementById(boxId).style.background = "linear-gradient(to top right, #EAEBED 0%, #EAEBED calc(50% - 3px), rgba(255,255,255,255) 50%, #EAEBED calc(50% + 3px), #EAEBED 100%)";
         document.getElementById("txt-"+boxId).style.color="#5F6163";
         document.getElementById("txt-"+boxId).style.opacity="1";
         document.getElementById("txt-"+boxId).style.fontWeight= "bold";

    }else{
       $('#BIS_trigger').remove();
       $('#showButton').html("");
       document.getElementById(boxId).style.background = "gray";
       document.getElementById("txt-"+boxId).style.color="white";
    }
  
  	var data= $("#info").val();
 	var typeShow = $("#typeShow").val();
  
  	if(data != boxId){
      
          
      	  var data = $("#info").val();
      	  $("#showSize").empty();
          $("#showSize").append(boxId);
          $("#SingleOptionSelector-0").val(str).change();
      	  document.getElementById(boxId).style.border = "solid #EAEBED 1px";
   
          if(data != 0)
          {
            if(typeShow == 2){
              document.getElementById(data).style.border = "solid #EAEBED 0px";
              document.getElementById(data).style.border = "1px solid #EAEBED";
              document.getElementById(data).style.background = "white";
              document.getElementById("txt-"+data).style.color="#5F6163";
              document.getElementById("txt-"+data).style.fontWeight= "normal";
              document.getElementById("txt-"+data).style.opacity="0.3";
            
            }else{
               document.getElementById(data).style.border = "solid #EAEBED 0px";
               document.getElementById(data).style.border = "1px solid #EAEBED";
               document.getElementById(data).style.background = "white";
               document.getElementById("txt-"+data).style.color="#5F6163";
            }
      }
      $("#info").val(boxId);
      $("#typeShow").val(id);
  	}
}
  